module.exports = {"610323100":"凤鸣镇","610323101":"蔡家坡镇","610323103":"益店镇","610323104":"蒲村镇","610323106":"青化镇","610323107":"枣林镇","610323108":"雍川镇","610323111":"故郡镇","610323112":"京当镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610323.json
// module id = 2590
// module chunks = 0